export default __webpack_public_path__ + "static/media/side-banner.553a0c8e.jpeg";